import { ReactElement } from 'react';
import GenericBanner from './GenericBanner'; // ajuste o caminho conforme necessário
import styles from './Banner.module.scss'; // usa os mesmos estilos

interface BannerProps {
  title: string;
  subtitle: string;
  imgSrc: string;
}

const Banner = ({ title, subtitle, imgSrc }: BannerProps): ReactElement => {
  return (
    <GenericBanner
      imgSrc={imgSrc}
      slotTop={<h1 className={styles["text-banner"]}>{title}</h1>}
      slotMiddle={<p className={styles["text-banner"]}>{subtitle}</p>}
      parallax={true}
      parallaxStart={-700}
    />
  );
};

export default Banner;
